/**
 * Lease Calculation Utilities
 * P20250925-125 — Single source of truth for lease math
 */

/**
 * Calculate lease monthly from BIN price
 * Formula: (BIN / term) * 1.03 (3% processing fee), rounded up nicely
 */
export function leaseFromBIN(
  binUsd: number,
  termMonths: number,
): {
  monthly: number;
  copy: string;
} {
  const baseMonthly = binUsd / termMonths;
  const withFee = baseMonthly * 1.03; // 3% processing fee

  // Nice rounding: round to nearest $10 if under $500, else $50
  let monthly: number;
  if (withFee < 500) {
    monthly = Math.ceil(withFee / 10) * 10;
  } else {
    monthly = Math.ceil(withFee / 50) * 50;
  }

  const copy = `$${monthly.toLocaleString()}/mo`;

  return { monthly, copy };
}

/**
 * Format lease price as daily equivalent
 */
export function leaseDailyEquivalent(monthlyUsd: number): string {
  const daily = (monthlyUsd * 12) / 365;
  return `~$${daily.toFixed(2)}/day`;
}
